import axiosInstance from '../axiosInterceptor/axiosInstance'

// Returns { hasAcceptedCurrentTos, lastAcceptedTosVersionId, lastAcceptedVersionTag, lastAcceptedAt }
// skipErrorNotification: the popup is opportunistic — we don't want a snackbar
// flashing on every page load if the request fails for a benign reason.
const getConsentStatus = () =>
  axiosInstance.get('v1/consent/me', { skipErrorNotification: true }).then((r) => r.data)

export default getConsentStatus
